<template>
  <pt-banner-table class="pt-banner-table__withData" @getTableData="getTableData" :tableLabels="tableLabels" :totalNumber="totalNumber" :tableData="tableData" v-loading="loading">
      <slot/>
  </pt-banner-table>
</template>

<script>
import PtBannerTable from './index'
export default {
  name: 'pt-banner-table__withData',
  components: {
    'pt-banner-table': PtBannerTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      loading: false
    }
  },
  methods: {
    getTableData () {
      this.loading = true
      this.$store.dispatch('bannersPositions').then(res => {
        this.$set(this, 'tableData', res)
        this.tableData = res
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取广告位列表失败')
      })
    }
  },
  created () {
    this.getTableData()
  }
}
</script>
